import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE, delay: i * 0.12 },
  }),
};

export function Reveal({ children, delay = 0, className = "", as = "div", testid }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      data-testid={testid}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </Tag>
  );
}

export function MaskedLine({ children, delay = 0, className = "", ready = true }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "115%" }}
        animate={ready ? { y: "0%" } : { y: "115%" }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Eyebrow({ children, light = false }) {
  return (
    <span
      className={`inline-flex items-center gap-4 text-[11px] md:text-xs font-medium uppercase tracking-widest2 ${
        light ? "text-gold-2" : "text-gold"
      }`}
    >
      <span className="h-px w-10 bg-current opacity-70" />
      {children}
    </span>
  );
}
